import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';
import {
  useFlags as useFlagsRouting,
  useService,
} from '@mint-lib/routing-context';
import { UserDetailsIntegrations } from '@mint-sdk/api-integrations';

import { USERS_SUMMARY } from '../../constants/EndpointConstants.js';
import { USERS_LIST } from '../../constants/queryKeys.js';

export const getUsersList = async (usersIds: string[]) => {
  const { data } = await api.get<
    Array<{ id: number; firstName: string; lastName: string }>
  >(`${USERS_SUMMARY}?ids=${usersIds.join(',')}`);
  return data;
};

export const useUsersDetailsList = (usersIds: string[]) => {
  const ff = useFlagsRouting('@mint/arm', ['integrationsQuerySdk']);
  const isIntegrationsQuerySdkEnabled = ff?.integrationsQuerySdk?.enabled;
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });
  const { data: dataOld, isSuccess: isSuccessOld } = useQuery({
    queryKey: [USERS_LIST],
    queryFn: () => getUsersList(usersIds),
    enabled: usersIds.length > 0 && !isIntegrationsQuerySdkEnabled,
  });

  const { data, isSuccess } = useQuery(
    {
      ...UserDetailsIntegrations.getUserDetails({
        urlParams: {
          userIds: usersIds.join(','),
        },
      }),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: usersIds.length > 0 && isIntegrationsQuerySdkEnabled,
    },
    queryClient,
  );

  const dataElem = isIntegrationsQuerySdkEnabled ? data : dataOld;
  const isSuccessElem = isIntegrationsQuerySdkEnabled
    ? isSuccess
    : isSuccessOld;

  return {
    usersList: !usersIds.length ? [] : (dataElem ?? []),
    isSuccess: isSuccessElem,
  };
};
